var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2803 6.21967C9.98744 5.92678 9.51256 5.92678 9.21967 6.21967C8.92678 6.51256 8.92678 6.98744 9.21967 7.28033L11.25 9.31066V14.25C11.25 14.6642 11.5858 15 12 15C12.4142 15 12.75 14.6642 12.75 14.25V9.31066L14.7803 7.28033C15.0732 6.98744 15.0732 6.51256 14.7803 6.21967C14.4874 5.92678 14.0126 5.92678 13.7197 6.21967L12 7.93934L10.2803 6.21967ZM17.607 14.0773C16.9464 14.8838 16.3324 15.6333 16.0025 16.5436C16.2925 16.6472 16.5 16.9244 16.5 17.25C16.5 17.6642 16.1642 18 15.75 18H8.25C7.83579 18 7.5 17.6642 7.5 17.25C7.5 16.9244 7.70751 16.6472 7.99751 16.5436C7.66759 15.6333 7.05359 14.8838 6.39295 14.0773C5.15356 12.5643 3.75 10.8509 3.75 7.5C3.75 3.35786 7.85786 0 12 0C16.1421 0 20.25 3.35786 20.25 7.5C20.25 10.8509 18.8464 12.5643 17.607 14.0773ZM8.25 19.5C7.83579 19.5 7.5 19.8358 7.5 20.25C7.5 20.6642 7.83579 21 8.25 21H15.75C16.1642 21 16.5 20.6642 16.5 20.25C16.5 19.8358 16.1642 19.5 15.75 19.5H8.25ZM9.75 22.5C9.33579 22.5 9 22.8358 9 23.25C9 23.6642 9.33579 24 9.75 24H14.25C14.6642 24 15 23.6642 15 23.25C15 22.8358 14.6642 22.5 14.25 22.5H9.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/light-solid.b4a958d1ff26d7a4a69d81a4a878521c.svg";